// AuthContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [sessionExpired, setSessionExpired] = useState(false); // State for session expiration
  const navigate = useNavigate(); // Initialize navigate

  const login = (userData) => {
    setUser(userData);
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('authToken');
    localStorage.removeItem('user_id');
    localStorage.removeItem('corporate_account');
    localStorage.removeItem('account_description');
    localStorage.removeItem('default_project');
    localStorage.removeItem('current_project');


         //  console.log('inside logout function'); // Debug log

   // navigate('/LoginAndAuthentication'); // Redirect to login page
  };

  const checkTokenExpiration = () => {
    const login_token = localStorage.getItem('authToken');
    if (login_token) {
      const decodedToken = jwtDecode(login_token);
      // console.log('decoded token 1', decodedToken.exp); // Debug log
      // console.log('decoded user id ', decodedToken.user_id); // Debug log
       localStorage.setItem('user_id', decodedToken.user_id);
    const user_id = localStorage.getItem('user_id');
    //   console.log('decoded user id from local storage ', user_id); // Debug log




      if (decodedToken.exp * 1000 < Date.now()) {
                   console.log('decoded token 2', decodedToken.exp); // Debug log

        setSessionExpired(true); // Show session expired popup
        logout();
      } else {
        setUser(decodedToken.user);
      }
    }
  };

  useEffect(() => {
    checkTokenExpiration();
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
      {sessionExpired && (
       // <div className="session-expired-popup">




             <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', backgroundColor: 'white', padding: '40px', boxShadow: '0 0 20px rgba(0,0,0,0.2)', border: '2px solid black', textAlign: 'center' }}>
              <p>Session Expired. Please Login Again.</p>
              <br /><br />
              <button onClick={() => { setSessionExpired(false); navigate('/LoginAndAuthentication'); }} style={{ backgroundColor: 'red', color: 'white', padding: '10px 20px', border: 'none', borderRadius: '5px' }}>Close</button>
            </div>

      )}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};